
import request from '@/http/request';
import storage from '@/utils/jeepayStorageWrapper.js'
// 定义全局自增ID
var atomicLong = 1
let timer = null;

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/** 生成自增序列号（不重复） **/
export function genRowKey () {
  return new Date().getTime() + '_' + (atomicLong++)
}

export function commonFetch(config, toast) {
  return request.request({
    ...config
  }).then(res => {
    return res
  }).catch((err) => {
    if (err.code !== 0) {
      toast({
        title: err.msg,
        status: "error",
      })
    }
    if (err.status) {
      if (err.status === 401) {
        toast({
          title: '登录过期，请重新登录',
          status: "error",
        })
        storage.cleanToken()
        clearTimeout(timer)

        timer = setTimeout(() => {
          window.location.href = '/auth/sign-in'
        }, 1000)
      } else {
        toast({
          title: err.msg,
          status: "error",
        })
      }
    }
    return Promise.reject(err)
  })
}